function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#64B5F6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.364 16.238l-.445-1.181-.79-2.096C24.453 11.162 22.838 10 21.014 10h-5.027c-1.823 0-3.439 1.162-4.116 2.96l-.789 2.096-.445 1.182C9.682 16.624 9 17.598 9 18.748v2.019c0 .678.244 1.29.633 1.763v2.274c0 .743.568 1.346 1.267 1.346h1.267c.7 0 1.266-.603 1.266-1.346v-1.346h10.134v1.346c0 .743.567 1.346 1.266 1.346H26.1c.7 0 1.267-.603 1.267-1.346V22.53c.39-.473.633-1.085.633-1.763v-2.02c0-1.149-.682-2.123-1.636-2.509zm-12.142-2.277c.289-.767.987-1.27 1.764-1.27h5.027c.778 0 1.476.503 1.765 1.27l.789 2.095H13.433l.79-2.096zm-2.055 6.797c-.76 0-1.267-.536-1.267-1.341 0-.805.507-1.342 1.267-1.342.76 0 1.9 1.207 1.9 2.012 0 .805-1.14.671-1.9.671zm12.666 0c-.76 0-1.9.134-1.9-.67 0-.806 1.14-2.013 1.9-2.013s1.267.537 1.267 1.342-.507 1.341-1.267 1.341z",
  fill: "#E3F2FD"
});

function SvgVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgVehicle;